import { Http } from '@services/http';

export const customClient = async <T>({
  url,
  method,
  params,
  data,
}: {
  url: string;
  method: 'get' | 'post' | 'put' | 'delete' | 'patch';
  params?: any;
  data?: BodyType<unknown>;
  responseType?: string;
}): Promise<T> => {
  switch (method) {
    case 'get':
      return await Http.getInstance().get({ path: url, searchParams: params, version: 'v2' });
    case 'post':
      return await Http.getInstance().post({ path: url, body: data, version: 'v2' });
    case 'put':
      return await Http.getInstance().put({ path: url, body: data, version: 'v2' });
    case 'delete':
      return await Http.getInstance().destroy({ path: url, version: 'v2' });
    default:
      throw new Error(`Method ${method} is not managed by custom client.`);
  }
};

export type ErrorType<ErrorData> = ErrorData;

export type BodyType<BodyData> = BodyData & { headers?: any };
